import { ApiCore } from '@/services/api/utils/core.js'

const url = 'data-elements/requests'
const plural = 'requests'
const single = 'request'

const api = new ApiCore({
	index: true,
	findOne: false,
	findAll: true,
	create: false,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

export default api
